module.exports = __webpack_public_path__ + "img/6.87a860b9.jpg";